var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridPage',{ref:"gridPage",attrs:{"form-default":{
            user_item_caches_id: [],
            user_item_caches: {},
            user_item_caches_sku: {},
            margin: 0,
            status: 'activated',
            is_single: true,
            details: {
                amazon: {
                    shipping_speed_category: 'Standard',
                },
                woo: {
                    sync_data: '',
                },
            },
            listings: {
                ebay: {
                    title: '',
                    category_id: '',
                    item_specifics: [],
                },
            },
            filters: {
                country: null,
            },
        },"filters-default":{
            status: '',
            sort: '-ordered_at',
        },"filter-items":[
            {
                vModel: 'is_canceled',
                title: 'キャンセル',
                options: [
                    { text: '全て', value: '' },
                    { text: 'キャンセル', value: '1' },
                    { text: '通常', value: '0' } ],
            },
            {
                vModel: 'is_deleted',
                title: '同期解除',
                options: [
                    { text: '全て', value: '' },
                    { text: '同期解除', value: '1' },
                    { text: '通常', value: '0' } ],
            },
            {
                vModel: 'sort',
                title: '順番',
                options: [
                    { text: '▲注文日時', value: 'ordered_at' },
                    { text: '▼注文日時', value: '-ordered_at' } ],
            } ],"filters-q-placeholder":"注文番号、追跡番号","form-modal-id":"user_order","search-action":"user_order/index","row-class":"flex-nowrap mx-0 my--2","hide-table":true,"hide-add":true},scopedSlots:_vm._u([{key:"form",fn:function(ref){
        var form = ref.form;
        var init = ref.init;
return [_c('UserOrder',{attrs:{"model":form,"init":init},on:{"save":_vm.$refs.gridPage.save,"destroy":_vm.$refs.gridPage.destroy}})]}},{key:"after-table",fn:function(){return [(_vm.$refs.gridPage && _vm.$refs.gridPage.grid.response.data && _vm.$refs.gridPage.grid.response.data.hits && _vm.$refs.gridPage.grid.response.data.hits.length)?[_c('div',{staticClass:"table-wrapper mt-3"},[_c('table',{staticClass:"table table-bordered table-hover"},[_c('thead',{staticClass:"thead-dark"},[_c('tr',{staticStyle:{"position":"sticky","top":"0","z-index":"1"}},[_c('th',{staticClass:"sticky-header",staticStyle:{"width":"12em"}},[_vm._v("Store")]),_vm._v(" "),_c('th',{staticClass:"sticky-header",staticStyle:{"width":"auto"}},[_vm._v("Inventory")]),_vm._v(" "),_c('th',{staticClass:"sticky-header",staticStyle:{"width":"12em"}},[_vm._v("注文日時")]),_vm._v(" "),_c('th',{staticClass:"sticky-header",staticStyle:{"width":"18em"}},[_vm._v("出荷日時/追跡番号")]),_vm._v(" "),_c('th',{staticClass:"sticky-header",staticStyle:{"width":"12em"}},[_vm._v("キャンセル日時")]),_vm._v(" "),_c('th',{staticClass:"sticky-header",staticStyle:{"width":"12em"}},[_vm._v("同期解除日時")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.$refs.gridPage.grid.response.data.hits),function(item){return _c('tr',{key:item.uuid,on:{"click":function($event){return _vm.$refs.gridPage.detail(item)}}},[_c('td',[_c('small',[_vm._v("\n                                        "+_vm._s(item.store_id)+"@"+_vm._s(item.store_provider)+"\n                                    ")]),_vm._v(" "),_c('br'),_vm._v("\n                                    "+_vm._s(item.store_order_id)+"\n                                ")]),_vm._v(" "),_c('td',[_c('small',[_vm._v("\n                                        "+_vm._s(item.inventory_id)+"@"+_vm._s(item.inventory_provider)+"\n                                    ")]),_vm._v(" "),_c('br'),_vm._v("\n                                    "+_vm._s(item.inventory_order_id)+"\n                                ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.ordered_at))]),_vm._v(" "),_c('td',[_vm._v("\n                                    "+_vm._s(item.shipped_at)),_c('br'),_vm._v(" "),_vm._l(((item.tracking_codes || [])),function(code){return _c('div',[_c('small',[_vm._v("\n                                            "+_vm._s(code.number)+"@"+_vm._s(code.carrier)+"\n                                        ")])])})],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.canceled_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.deleted_at))])])}),0)])])]:_vm._e()]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }